import axios from "axios"

const instance = axios.create({

})

// instance.options.emulateHTTP = true
// instance.options.emulateJSON = true

export default instance
